import React, {useState, useContext, useEffect} from 'react';
import GroupRadioButton from '../../../common-scripts/CustomFields/GroupRadioButton';
import * as Yup from 'yup';
import {useFormik} from 'formik';
import {AppContext} from '../Context';
import UtilFunctions from "../../../common-scripts/Helpers/Utils";

/**
 * Step Mes votontés
 *
 * @param texteInfos
 * @param userData
 * @param checkReadyForSaving
 * @returns {JSX.Element}
 * @constructor
 */
const StepWills = ({texteInfos, userData = null, checkReadyForSaving}) => {

	const {currentStep, dispatchStepEvent, datas, setdatas, referencesUrls} = useContext(AppContext);

	const initialValues = (userData != undefined || userData != null) ? userData : {
		burialMode: {
			type: '',
			burialInfos: {
				nameCemetery: '',
				address: '',
				nameConcesionHolder: '',
				numConcession: '',
				relationshipWithConcessionHolder: '',
				placesRemaining: '',
				durationConcession: '',
				otherDuration: '',
			},
			cremationInfos: {
				destination: '',
				place: ''
			}
		},
		ceremony: ''
	}
	const [sepultures, setSepultures] = useState([
		{
			is_selected: false,
			libelle: 'Crémation',
			icon_code: 'cr1',
			infobulle: 'La crémation consiste à réduire en cendres le corps du défunt pour ensuite être dispersées ou conservées dans une urne. L\'urne peut être inhumée où scellée sur la sépulture.'
		},
		{
			is_selected: false,
			libelle: 'Inhumation',
			icon_code: 'in',
			infobulle: 'L\'inhumation consiste à placer le cercueil dans une sépulture située le plus souvent dans le cimetière du lieu d\'habitation du défunt, du lieu du décès ou celui du caveau familial.'
		},
	].map((data) => {
		if (data.libelle == initialValues.burialMode.type)
			return {...data, is_selected: true}
		else
			return data;

	}));
	const [ceremonies, setCeremonies] = useState([
		{is_selected: false, libelle: 'Cérémonie civile', icon_code: 'cc', infobulle: 'La cérémonie civile (ou cérémonie laïque) est adaptée aux personnes ne souhaitant pas de cérémonie religieuse. L’hommage est préparé en lien avec un conseiller funéraire et un maître de cérémonie.'},
		{is_selected: false, libelle: 'Cérémonie religieuse', icon_code: 'rel', infobulle: ''},
		{is_selected: false, libelle: 'Aucune cérémonie', icon_code: 'non', infobulle: ''},
	].map((data) => {
		if (data.libelle == initialValues.ceremony)
			return {...data, is_selected: true}
		else
			return data;

	}));

	/**
	 * On change group radio
	 *
	 * @param {number} id
	 * @param {string} group
	 */
	const onChangeGroupRadio = (id, group) => {
		switch (group) {
			case 'ceremonies':
				setCeremonies(ceremonies.map((data, index) => {
					if (index == id) {
						formik.setFieldValue("ceremony", data.libelle);
						formik.setTouched({...formik.touched, "ceremony": true})
						return {...data, is_selected: true}
					} else {
						return {...data, is_selected: false}
					}
				}));
				break;
			case 'sepulture':
				setSepultures(sepultures.map((data, index) => {
					if (index == id) {
						formik.setFieldValue("burialMode.type", data.libelle)
						formik.setTouched({...formik.touched, "burialMode.type": true})
						return {...data, is_selected: true}
					} else {
						return {...data, is_selected: false}
					}

				}));
				break;
		}
	}

	const validationSchema = Yup.object({
		burialMode: Yup.object().shape(
			{
				type: Yup.string().required('Merci de renseigner le Mode de sépulture'),
				burialInfos: Yup.object().shape({

					nameCemetery: Yup.string(),
					address: Yup.string(),
					nameConcesionHolder: Yup.string(),
					relationshipWithConcessionHolder: Yup.string(),
					placesRemaining: Yup.number().positive('Le nombre de place doit être positif'),
					durationConcession: Yup.string(),
					otherDuration: Yup.number().positive("Le nombre d'années doit être positif"),


				}),
				cremationInfos: Yup.object().shape({

					destination: Yup.string().notRequired(),
					place: Yup.string().max(50, 'Le nombre de caractères max est de 50'),

				}).when('type', {
					is: 'Crémation',
					then: Yup.object().shape({
						destination: Yup.string().required('Merci de renseigner la Destination'),
						place: Yup.string().max(50, 'Le nombre de caractères max est de 50'),
					})
				})

			}
		),
		ceremony: Yup.string().required('Merci de renseigner la cérémonie')
	});

	const formik = useFormik({
		validationSchema: validationSchema,
		initialValues: initialValues
	})

	useEffect(() => {

			checkReadyForSaving(Object.keys(formik.touched).length > 0);

			// Reset other duration field
			if (formik.values.burialMode.burialInfos.durationConcession !== 'Autre') {

				formik.setFieldValue("burialMode.burialInfos.otherDuration", "")
				formik.setTouched({...formik.touched, "burialMode.burialInfos.otherDuration": false})
			}

			formik.validateForm().then((res) => {
				datas[currentStep] = formik.values;
				setdatas(datas);
				if (Object.keys(res).length == 0) {
					dispatchStepEvent('SET_STEP_READY', true);
				} else {
					dispatchStepEvent('SET_STEP_READY', false)
				}

			});

		},

		[formik.values]
	);

	// console.log(formik.errors?.burialMode?.burialInfos?.placesRemaining);
	// console.log(formik.touched?.burialMode?.burialInfos?.placesRemaining);

	return <>
		<div id="step-2" className="step-form">

			<div className="card-banner info" dangerouslySetInnerHTML={{__html: texteInfos}}>

			</div>


			<form>
				<div className="form-card">
					<div className="card-header">
						Mode de sépulture :
					</div>
					<div className="card-body">


						<div className="bloc question picto valid  under-ligne">
							<h2 className="title small">Sélectionnez votre choix :</h2>
							<GroupRadioButton group={'sepulture'} radios={sepultures} onChange={onChangeGroupRadio}/>

							<input hidden={true} onBlur={formik.handleBlur} onChange={formik.handleChange}
								   value={formik.values.burialMode} id="burialMode" name="burialMode"/>
						</div>

						{
							sepultures.map((mode, index) => {


								if (mode.libelle == 'Crémation' && mode.is_selected) {
									return <div key={index} className="bloc question picto valid">
										<div className="form-group  ">
											<label className="control-label"
												   htmlFor="burialMode.cremationInfos.destination">Destination des
												cendres : </label>
											<div className="container-input">
												<div className="select-cont">
													<select className="form-control valid-required valid-req-ville-cp"
															onChange={formik.handleChange} onBlur={formik.handleBlur}
															value={formik.values.burialMode.cremationInfos.destination}
															name="burialMode.cremationInfos.destination">
														<option></option>
														<option> Dépôt de l’urne dans un columbarium</option>
														<option> Dépôt de l’urne sur/dans une sépulture</option>
														<option> Dispersion au jardin du souvenir</option>
														<option> Autre lieu autorisé</option>
														<option> Je laisse le choix à mon mandataire ou à défaut à mes
															proches
														</option>
													</select>
													<div className="select-after-icon">
														<i className="fa fa-chevron-down"></i>
													</div>
												</div>
												{(formik.errors.burialMode?.cremationInfos?.destination && formik.touched.burialMode?.cremationInfos?.destination) && (
													<span
														className="msg-error">{formik.errors.burialMode?.cremationInfos?.destination}</span>
												)}

											</div>
										</div>
										<div className="form-group ">
											<label className="control-label" htmlFor="burialMode.cremationInfos.place">Précisez
												le lieu (facultatif) : </label>
											<div className="container-input">
												<textarea maxLength={50} className="form-control"
														  onChange={formik.handleChange}
														  value={formik.values.burialMode.cremationInfos.place}
														  name="burialMode.cremationInfos.place" type="text"
														  placeholder=""
														  title="Précisez le type de composition souhaité"/>
												<span>{formik.values.burialMode.cremationInfos.place.length}/50 caractères</span>
											</div>
										</div>

									</div>

								} else if (mode.libelle == 'Inhumation' && mode.is_selected) {

									return <div key={index} className="bloc question picto valid">

										<div className="form-group  ">
											<label className="control-label" htmlFor="nameCemetery">Nom du cimetière (facultatif) : </label>
											<div className="container-input">
												<input className="form-control" onBlur={formik.handleBlur}
													   onChange={formik.handleChange}
													   value={formik.values.burialMode.burialInfos.nameCemetery}
													   name="burialMode.burialInfos.nameCemetery" type="text"
													   placeholder="Saisissez nom du cimetière "
													   title="Nom du cimetière"/>

											</div>
										</div>
										<div className="form-group  ">
											<label className="control-label" htmlFor="address">Adresse du cimetière (facultatif) : </label>
											<div className="container-input">
												<input className="form-control" onBlur={formik.handleBlur}
													   onChange={formik.handleChange}
													   value={formik.values.burialMode.burialInfos.address}
													   name="burialMode.burialInfos.address" type="text"
													   placeholder="Saisissez adresse du cimetière "
													   title="Adresse du cimetière"/>

											</div>
										</div>

										<div className="form-group  ">
											<label className="control-label" htmlFor="numConcession">Numéro de la
												concession (facultatif) : </label>
											<div className="container-input">
												<input className="form-control" onBlur={formik.handleBlur}
													   onChange={formik.handleChange}
													   value={formik.values.burialMode.burialInfos.numConcession}
													   name="burialMode.burialInfos.numConcession" type="text"
													   placeholder="Saisissez le numéro de la concession "
													   title="Numéro de la concession"/>

											</div>
										</div>
										<div className="form-group  ">
											<label className="control-label" htmlFor="nameConcesionHolder">Nom du
												titulaire de la concession (facultatif) : </label>
											<div className="container-input">
												<input className="form-control" onBlur={formik.handleBlur}
													   onChange={formik.handleChange}
													   value={formik.values.burialMode.burialInfos.nameConcesionHolder}
													   name="burialMode.burialInfos.nameConcesionHolder" type="text"
													   placeholder="Saisissez le nom du titulaire de la concession "
													   title="Nom du titulaire de la concession"/>

											</div>
										</div>
										<div className="form-group  ">
											<label className="control-label" htmlFor="relationshipWithConcessionHolder">Lien
												de parenté avec le titulaire de la concession (facultatif) : </label>
											<div className="container-input">
												<input className="form-control" onBlur={formik.handleBlur}
													   onChange={formik.handleChange}
													   value={formik.values.burialMode.burialInfos.relationshipWithConcessionHolder}
													   name="burialMode.burialInfos.relationshipWithConcessionHolder"
													   type="text"
													   placeholder="Saisissez le lien de parenté avec le titulaire de la concession "
													   title="Lien de parenté avec le titulaire de la concession"/>

											</div>
										</div>
										<div className="form-group  ">
											<label className="control-label" htmlFor="placesRemaining">Places restantes
												à ce jour (facultatif) : </label>
											<div className="container-input">
												<input
													className="form-control"
													onBlur={formik.handleBlur}
													onChange={formik.handleChange}
													value={formik.values.burialMode.burialInfos.placesRemaining}
													name="burialMode.burialInfos.placesRemaining"
													type="number"
													placeholder="Saisissez les places restantes à ce jour "
													title="Places restantes à ce jour"
													onKeyDown={UtilFunctions.preventNumericSymbols}
												/>

												{formik.errors?.burialMode?.burialInfos?.placesRemaining && formik.touched?.burialMode?.burialInfos?.placesRemaining ?
													<span className='msg-error'>{formik.errors?.burialMode?.burialInfos?.placesRemaining}</span> : null}

											</div>
										</div>
										<div className="form-group  ">
											<label className="control-label" htmlFor="durationConcession">Durée de la
												concession (facultatif) : </label>
											<div className="container-input">
												<div className="select-cont">
													<select className="form-control " onBlur={formik.handleBlur}
															onChange={formik.handleChange}
															value={formik.values.burialMode.burialInfos.durationConcession}
															name="burialMode.burialInfos.durationConcession">
														<option></option>
														<option value={'Perpétuelle'}> Perpétuelle</option>
														<option value={'5 ans'}> 5 ans</option>
														<option value={'10 ans'}> 10 ans</option>
														<option value={'15 ans'}> 15 ans</option>
														<option value={'20 ans'}> 20 ans</option>
														<option value={'30 ans'}> 30 ans</option>
														<option value={'Autre'}> Autre </option>

													</select>
													<div className="select-after-icon">
														<i className="fa fa-chevron-down"></i>
													</div>
												</div>

											</div>
										</div>

										{ formik.values.burialMode.burialInfos.durationConcession === "Autre" && (
											<div className="form-group  ">
												<label className="control-label" htmlFor="otherDuration">Durée (en années) : </label>
												<div className="container-input">
													<input
														className="form-control"
														onBlur={formik.handleBlur}
														onChange={formik.handleChange}
														value={formik.values.burialMode.burialInfos.otherDuration}
														name="burialMode.burialInfos.otherDuration"
														type="number"
														placeholder="Saisissez la durée (en années) "
														title="Durée de la concession"
														onKeyDown={UtilFunctions.preventNumericSymbols}
													/>
													{formik.errors?.burialMode?.burialInfos?.otherDuration && formik.touched?.burialMode?.burialInfos?.otherDuration ?
														<span className='msg-error'>{formik.errors?.burialMode?.burialInfos?.otherDuration}</span> : null}

												</div>
											</div>
										)}

									</div>

								}
							})
						}
					</div>
				</div>

				<div className="form-card">
					<div className="card-header">
						Cérémonie :
					</div>
					<div className="card-body">

						<div className="bloc question picto valid">
							<h2 className="title small">Sélectionnez votre choix :</h2>

							<GroupRadioButton onChange={onChangeGroupRadio} group={'ceremonies'} radios={ceremonies}/>
							<input hidden={true} onBlur={formik.handleBlur} onChange={formik.handleChange}
								   value={formik.values.ceremony} id="ceremony" name="ceremony"/>

						</div>
					</div>
				</div>
			</form>
		</div>
	</>;
};

export default StepWills;
